import { Component, OnInit, Input } from '@angular/core';
import { variableGlobal } from "../global.enum";

@Component({
  selector: 'app-cargando',
  templateUrl: './cargando.component.html',
  styleUrls: ['./cargando.component.css']
})
export class CargandoComponent implements OnInit {

  constructor() { }

  logoUrl: string = variableGlobal.RUTA_IMAGEN_LOGO;
  @Input() mensaje: string = 'Cargando...';

  ngOnInit(): void {
  }

}
